module.exports = __webpack_public_path__ + "static/media/50_weeks.44550bea.png";